export default function MailIcon(params: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...params} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 5.5H4C3.60218 5.5 3.22064 5.65804 2.93934 5.93934C2.65804 6.22064 2.5 6.60218 2.5 7V24C2.5 24.663 2.76339 25.2989 3.23223 25.7678C3.70107 26.2366 4.33696 26.5 5 26.5H27C27.663 26.5 28.2989 26.2366 28.7678 25.7678C29.2366 25.2989 29.5 24.663 29.5 24V7C29.5 6.60218 29.342 6.22064 29.0607 5.93934C28.7794 5.65804 28.3978 5.5 28 5.5ZM24.1437 8.5L16 15.965L7.85625 8.5H24.1437ZM5.5 23.5V10.41L14.9862 19.1063C15.2629 19.3599 15.6246 19.5007 16 19.5007C16.3754 19.5007 16.7371 19.3599 17.0138 19.1063L26.5 10.41V23.5H5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
